module.exports = {
  '@primary-color': '#3B5C7A',
};

